import { Injectable } from "@angular/core";
import { AlertsService } from "@services/alerts.service";

@Injectable({
  providedIn: "root",
})
export class MenuListService {
  constructor(private alertsService: AlertsService) {}

  getGlobalMenu(instanceData, roleData) {
    let menuItems = [
      {
        title: "Home",
        translation_key: "home",
        link: "/home",
        icon: { pack: "fas", icon: "home" },
        show: (instanceData, roleData) =>
          instanceData?.scaffoldType?.includes("datax"),
      },
      {
        title: "Dashboard",
        translation_key: "dashboard",
        link: "/home",
        icon: { pack: "fas", icon: "home" },
        show: (instanceData, roleData) => {
          return (
            !instanceData?.scaffoldType?.includes("datalink") &&
            !instanceData?.scaffoldType?.includes("ai-detection") &&
            !instanceData?.scaffoldType?.includes("datax") &&
            !instanceData?.scaffoldType?.includes("archivev2")
          );
        },
      },

      // {
      //   title: "Migrations",
      //   translation_key: "migrations",
      //   link: "/migrations",
      //   icon: { pack: "fas", icon: "cubes-stacked" },
      //   show: (instanceData, roleData) => {
      //     return (
      //       instanceData?.scaffoldType?.includes("migration")&&roleData?.view_admin
      //     );
      
      //   },
      // },

      {
        title: "Imports",
        translation_key: "imports",
        link: "/imports",
        icon: { pack: "fas", icon: "cubes-stacked" },
        tourId: "create-import,create-integration",
        stepId: "step-2,step-2",
        position: "bottom-14,bottom-14",
        show: (instanceData, roleData) => {
          return (
            instanceData?.scaffoldType?.includes("archivev2") &&
            roleData?.view_admin &&
            !instanceData.no_self_serve
          );
        },
      },

      {
        title: "AI Detection",
        translation_key: "ai_detection",
        link: "/ai-detection-report",
        icon: { pack: "fas", icon: "computer-classic" },
        show: (instanceData, roleData) =>
          instanceData?.scaffoldType?.includes("ai-detection") &&
          roleData?.view_admin,
      },
      /*   {
        title: "Archive",
        translation_key: "archive",
        link: "/batch-details",
        icon: { pack: "fa", icon: "container-storage" },
        show: (instanceData, roleData) => instanceData?.scaffoldType?.includes('archivev2'),
      }*/
      {
        title: "Courses",
        link: "/courses",
        translation_key: "courses",
        icon: { pack: "fas", icon: "book-open" },
        show: (instanceData, roleData) => {
          return !instanceData?.scaffoldType?.includes("datax");
        },
      },
      {
        title: "People",
        translation_key: "people",
        link: "/accounts",
        icon: { pack: "fa", icon: "user-graduate" },
        show: (instanceData, roleData) =>
          instanceData?.scaffoldType?.includes("archivev2"),
      },

      {
        title: "documentation",
        translation_key: "documentation",
        link: "/documentation",
        icon: { pack: "fa", icon: "book" },
        show: (instanceData, roleData) =>
          instanceData?.scaffoldType?.includes("datax"),
      },
      {
        title: "snowflake",
        translation_key: "snowflake",
        link: "/snowflake",
        icon: { pack: "fa", icon: "chart-network" },
        show: (instanceData, roleData) =>
          instanceData?.scaffoldType?.includes("datax") &&
          roleData?.view_snowflake,
      },
      {
        title: "analytics",
        translation_key: "analytics",
        link: "/analytics",
        icon: { pack: "fa", icon: "chart-line" },
        show: (instanceData, roleData) =>
          instanceData?.scaffoldType?.includes("datax") &&
          (roleData?.view_sigma ||
            roleData?.manage_sigma ||
            roleData?.manage_worksheets),
      },

      {
        title: "lakehouse",
        translation_key: "lakehouse",
        link: "/lakehouse",
        icon: { pack: "fa", icon: "database" },
        show: (instanceData, roleData) =>
          instanceData?.scaffoldType?.includes("datax"),
      },
      {
        title: "Users & Roles",
        translation_key: "users_and_roles",
        link: "/users",
        icon: { pack: "fa", icon: "users" },
        tourId: "inviting-users",
        stepId: "step-2",
        position: "bottom-14",
        show: (instanceData, roleData) => roleData?.manage_users,
      },
      {
        title: "Tools",
        translation_key: "tools",
        link: "/lti",
        icon: { pack: "fas", icon: "link" },
        show: (instanceData, roleData) => {
          roleData?.manage_tools &&
            instanceData?.scaffoldType?.includes("designer");
        },
      },
      {
        title: "Configure",
        translation_key: "configure",
        link: "/data-models",
        icon: { pack: "fas", icon: "key" },
        show: (instanceData, roleData) => roleData?.manage_views,
      },
      {
        title: "Alerts",
        translation_key: "alerts",
        link: "/alerts",
        icon: { pack: "fas", icon: "bell" },
        badge: () => {
          return this.alertsService.getActiveCount();
        },
        show: (instanceData, roleData) =>
          instanceData?.scaffoldType?.includes("datax") && roleData?.view_admin,
      },
      {
        title: "Admin",
        translation_key: "admin",
        link: "/admin",
        icon: { pack: "fas", icon: "list-alt" },
        tourId: "scaffold-theme-setup",
        stepId: "step-2",
        position: "bottom-14",
        show: (instanceData, roleData) => roleData?.view_admin,
      },
    ];
    return menuItems.filter((item) => {
      return item.show(instanceData, roleData);
    });
  }

  getMenuFooter(instanceData, roleData) {
    let footerMenu = [
      {
        type: "modal",
        icon: "fa-solid fa-question",
        modal: "quick_help",
        title: "Quick Help",
        translation_key: "quick_help",
        show: (instanceData, roleData) =>
          roleData?.view_admin &&
          instanceData?.scaffoldType === "archivev2" &&
          !instanceData?.no_self_serve,
      } /*{
            {
        type: "modal",
        icon: "fa-regular fa-hat-wizard fa-fw",
        modal: "wizard",
        title: "Wizard",
        translation_key: "wizard",
        show: (instanceData, roleData) => roleData?.view_admin && instanceData?.scaffoldType === "archivev2",
      },*/,

      {
        type: "link",
        link: "changes",
        translation_key: "changes",
        icon: "fa-regular fa-memo-circle-info",
        title: "Changes",
        show: (instanceData, roleData) => true,
      },
      {
        type: "url",
        url: "https://app.conveyor.com/profile/k16-solutions",
        translation_key: "trust_portal",
        icon: "fa-solid fa-shield-check",
        title: "Trust Portal",
        show: (instanceData, roleData) => true,
      },
      /*  {
        type: "link",
        link: "security",
        translation_key: "security",
        icon: "fa-solid fa-shield-check",
        title: "Security",
        show: (instanceData, roleData) => true,
      },*/
    ];
    return footerMenu.filter((item) => {
      return item.show(instanceData, roleData);
    });
  }

  getAdminMenu(roleData) {
    let adminMenu = [
      {
        translation_key: "admin",
        text: "Admin",
        route: "admin",
        directRoute: "../admin",
        hidden: true,
      },
      {
        translation_key: "user_accounts",
        text: "User Accounts",
        route: "user-accounts",
      },
      {
        translation_key: "integrations",
        text: "Integrations",
        route: "integrations",
        hidden: !roleData?.view_integrations,
      },
      {
        translation_key: "create",
        text: "Create",
        route: "create",
        avoidLink: true,

        hidden: true,
      },

      {
        translation_key: "edit",
        text: "Edit",
        route: "edit",
        avoidLink: true,

        hidden: true,
      },
      {
        translation_key: "styling",
        text: "Styling",
        route: "styling",
        tourId: "scaffold-theme-setup",
        stepId: "step-3",
        position: "right",
      },
      {
        text: "SSO",
        route: "sso",
        hidden: !roleData?.view_sso,
      }, 

      {
        text: "Data Retention",
        route: "dataretention",
        hidden: !roleData?.manage_data_retention
      },  
      {
        text: "User Data Management",
        route: "userdata",
        hidden: !roleData?.manage_user_data_removal
      },  
    ];
    return adminMenu;
  }
}
